import React from "react";

import { Modal, Form, Input, notification } from "antd";
import { FormInstance } from "antd/lib/form";

import BasicFolderTree from "components/imagemanager/foldertree/basic";

class CreateDir extends React.Component<any, any> {
  formRef = React.createRef<FormInstance>();

  constructor(props: any) {
    super(props);
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleTreeSelect = this.handleTreeSelect.bind(this);
    this.state = {
      selectedTreeNode: {},
      confirmLoading: false,
    };
  }

  handleOk = (e: any) => {
    const { onFolderNameCheck, onCreateDir } = this.props;
    this.setState({
      confirmLoading: true,
    });
    // 1.验证表单字段
    this.formRef.current
      .validateFields()
      .then((values) => {
        const { folderName } = values;
        // 2.检查文件夹名是否重复
        onFolderNameCheck({ folderName }).then((res) => {
          if (res.data === 0) {
            const node = {
              pid: this.state.selectedTreeNode.id | this.props.parentFolder.id,
              folderName,
              folderType: "img",
            };
            // 3.请求接口创建文件夹
            onCreateDir(node).then((res) => {
              if (res.data) {
                this.props.onOK(e);
                notification.success({
                  message: "操作成功",
                  description: `文件夹{${folderName}}创建成功`,
                  duration: 2,
                });
              }
            });
          } else {
            // todo 创建文件夹失败
          }
        });
      })
      .catch((errInfo) => {
        this.setState({
          confirmLoading: false,
        });
        console.log("Validate Failed:", errInfo);
      });
  };

  handleCancel = (e: any) => {
    this.props.onOK(e);
  };

  handleTreeSelect(value, option) {
    // console.log(value, option);
    this.setState({
      selectedTreeNode: option,
    });
  }

  render() {
    const { treeData, parentFolder } = this.props;
    const { confirmLoading } = this.state;
    const { key } = parentFolder;
    const initialValues = Object.assign({}, { parentFolder: key });
    return (
      <Modal
        maskClosable
        destroyOnClose
        visible={this.props.visible}
        confirmLoading={confirmLoading}
        title="新建文件夹"
        onOk={this.handleOk}
        onCancel={this.handleCancel}
      >
        <Form
          layout="vertical"
          name="form_in_modal"
          ref={this.formRef}
          initialValues={initialValues}
          scrollToFirstError
        >
          <Form.Item
            name="parentFolder"
            label="父文件夹"
            rules={[{ required: true, message: " " }]}
          >
            <BasicFolderTree
              onTreeSelect={this.handleTreeSelect}
              treeData={treeData}
            />
          </Form.Item>
          <Form.Item
            name="folderName"
            label="文件夹名"
            rules={[{ required: true, message: " " }]}
          >
            <Input type="textarea" />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default CreateDir;
